// import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Upload } from './api';
import './index.css';

import App from './App.jsx';
import createStore from 'rtk/react';
import '@rails/resource'; // inclus cable et document
import '@rails/upload';
import 'fullscreen-slice';
import 'history-slice';

import resourceMap from './api';
// DEBUG window.resources = resourceMap;
import { setResourceMap } from '@rails/document';
setResourceMap(resourceMap);
import { setUploadModel } from '@rails/upload/constants';
setUploadModel(Upload);

const Store = createStore({
  bootParams: {},
  ignoredPaths: [],
  ignoreActions: true,
});

createRoot(document.getElementById('root')).render(
  <Store>
    <App />
  </Store>,
);
/*
  <StrictMode>
  </StrictMode>,
  */
